import React from 'react';
import PropTypes from 'prop-types';
/* styles */
import './menu-item.scss';

class MenuItem extends React.PureComponent {
    handleItemClick = (event) => {
        if (!this.props.isDisabled) {
            if (this.props.linkTo) {
                window.location.href = this.props.linkTo;
            }
            if (this.props.onClick) {
                this.props.onClick(event);
            }
            if (!this.props.preventMenuClose) {
                this.context.toggleMenu(false, event);
            }
        }
    };

    render() {
        let menuItemClass = 'sten-menu-item flex flex-center';
        if (this.props.className) {
            menuItemClass += ` ${this.props.className}`;
        }
        if (!this.props.isDisabled && (this.props.onClick || this.props.linkTo)) {
            menuItemClass += ' sten-menu-item--clickable';
        }
        if (this.props.isDisabled) {
            menuItemClass += ' sten-menu-item--disabled';
        }
        return (
            <div className={menuItemClass} onClick={this.handleItemClick}>
                <div className="sten-menu-item__icon">
                    {this.props.icon && <span className={`icon ${this.props.icon}`} />}
                </div>
                <span className="sten-menu-item__text">{this.props.children}</span>
            </div>
        );
    }
}

MenuItem.contextTypes = {
    toggleMenu: PropTypes.func.isRequired
};

MenuItem.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    icon: PropTypes.string,
    isDisabled: PropTypes.bool,
    linkTo: PropTypes.string,
    onClick: PropTypes.func,
    preventMenuClose: PropTypes.bool
};

MenuItem.defaultProps = {
    children: null,
    className: '',
    icon: '',
    isDisabled: false,
    linkTo: '',
    onClick: undefined,
    preventMenuClose: false
};

export default MenuItem;
